import { useState } from 'react'
import { Sparkles } from 'lucide-react'
import AnnouncementList from './AnnouncementList.jsx'
import { useAnnouncements, useMarkAnnouncementsSeen } from '../../hooks/useAnnouncements.js'

/**
 * Cloche « Nouveautés » du topbar : badge des non-vus + panneau listant les
 * notes de version. Ouvrir le panneau marque tout comme vu.
 */
export default function AnnouncementsBell() {
  const [open, setOpen] = useState(false)
  const { data } = useAnnouncements()
  const markSeen = useMarkAnnouncementsSeen()

  const items = data?.items || []
  const unseenCount = data?.unseenCount || 0

  const toggle = () => {
    const next = !open
    setOpen(next)
    if (next && unseenCount > 0) markSeen.mutate()
  }

  return (
    <div className="relative">
      <button
        type="button"
        onClick={toggle}
        aria-label="Nouveautés"
        className="relative flex h-9 w-9 items-center justify-center rounded-full text-ink/70 transition hover:bg-ink/10 hover:text-ink"
      >
        <Sparkles size={18} />
        {unseenCount > 0 && (
          <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-brand px-1 text-[10px] font-bold text-white">
            {unseenCount > 9 ? '9+' : unseenCount}
          </span>
        )}
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-[90]" onClick={() => setOpen(false)} />
          <div className="absolute right-0 z-[100] mt-2 max-h-[70vh] w-80 overflow-y-auto rounded-2xl border border-ink/10 bg-canvas p-3 shadow-2xl">
            <h3 className="mb-3 px-1 text-sm font-semibold text-ink/80">Nouveautés</h3>
            <AnnouncementList items={items} compact />
          </div>
        </>
      )}
    </div>
  )
}
